import { createStyles } from '@/styles';

export default createStyles(() => ({
  classes: {
    panel: 'pt-0',
    content: 'text-fg-subtle txt-md pb-4',
  },
  styles: {
    panel: {},
    content: {},
  },
}));
